import React from 'react';
import Teamitem from '../Team/Teamitem';

const teamData = [
    {
        image: 'karl_img_only.png',
        memberN: 'Karl Lusted',
        title: 'CEO',
        socalDataKey: 'karl'
    },
    {
        image: 'gareth_img_only.png',
        memberN: 'Gareth Roddy',
        title: 'CTO',
        socalDataKey: 'gareth'
    }
]
const Team =()=>{
    return(
        <section className="experts_team_area">
            <div className="container">
                <div className="row justify-content-center">
                    {
                        teamData.map(item=>{
                            return(
                                <div className="col-lg-3 col-sm-6">
                                    <Teamitem teamImage={item.image} memberN={item.memberN} title={item.title} socalDataKey={item.socalDataKey} />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}
export default Team;